import { render, staticRenderFns } from "./SectionGroupData.vue?vue&type=template&id=1e6ce23c"
import script from "./SectionGroupData.vue?vue&type=script&lang=js"
export * from "./SectionGroupData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports